import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import { useLocation } from "react-router-dom";
import { routePath } from "../assets/routes";
import { screenshots } from "../assets/screenshots";
import { PageMeta } from "../components/PageMeta";
import { landingByLocale, termsByLocale } from "../content";
import type { Locale } from "../content/types";
import { Footer } from "../sections/Footer";
import { Header } from "../sections/Header";

type TermsPageProps = {
  locale: Locale;
};

export function TermsPage({ locale }: TermsPageProps) {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const contentOnly = query.get("embed") === "1";
  const terms = termsByLocale[locale];
  const landing = landingByLocale[locale];

  return (
    <div className="page-shell">
      <PageMeta title={terms.seo.title} description={terms.seo.description} locale={locale} kind="terms" />
      {contentOnly ? null : <Header content={landing} locale={locale} page="terms" />}
      <main className="privacy-page">
        <article className="privacy-article">
          <div className="brand-link content-only-brand" aria-label="Prismark">
            <img src={screenshots.icon} alt="Prismark" width="28" height="28" />
            <span>Prismark</span>
          </div>
          <h1>{terms.title}</h1>
          <p className="privacy-updated">{terms.updated}</p>
          <div className="privacy-intro">
            {terms.intro.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          {terms.sections.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {section.body.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.bullets ? (
                <ul>
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
          {contentOnly ? null : (
            <aside className="privacy-link-card">
              <p>{terms.privacyLink.body}</p>
              <a
                href={routePath(terms.privacyLink.href)}
                onClick={() =>
                  trackEvent(AnalyticsEvents.PrivacyClick, {
                    product: "prismark",
                    page: "terms",
                    locale,
                    target: "terms_privacy"
                  })
                }
              >
                {terms.privacyLink.label}
              </a>
            </aside>
          )}
        </article>
      </main>
      {contentOnly ? null : <Footer content={landing.footer} locale={locale} page="terms" />}
    </div>
  );
}
